import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getStackMap = state => state.getIn(['ui', 'stackMap'], Immutable.Map());

export const selectStackMapData = createSelector([getStackMap], stackMap => stackMap.get('data'));

export const selectStackMapTransactions = createSelector([getStackMap], stackMap =>
  stackMap.get('stackMapTransactions')
);

export default {
  selectStackMapData,
  selectStackMapTransactions
};
